import { useEffect, useState } from 'react';
import { fetchUserAttributes, getCurrentUser } from '../utils/session';

/** First name of the signed-in user (`custom:firstName`, else the username), or '' until it is read. */
export const useSignedInName = (enabled = true): string => {
  const [name, setName] = useState('');
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    (async () => {
      try {
        const user = await getCurrentUser();
        const attributes = await fetchUserAttributes();
        if (alive) setName(attributes['custom:firstName'] || user.username || '');
      } catch {
        /* the menu still works without a name */
      }
    })();
    return () => { alive = false; };
  }, [enabled]);
  return name;
};
